import { useId } from 'react';

export const LogoMark = ({ gradientId }: { gradientId: string }) => (
  <>
    <defs>
      <radialGradient id={gradientId} cx="0.35" cy="0.30" r="0.8">
        <stop offset="0%" stopColor="#31447c" />
        <stop offset="100%" stopColor="#0f1830" />
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="37.5" fill={`url(#${gradientId})`} />
    <rect
      x="48.4"
      y="37.5"
      width="3.2"
      height="12.5"
      rx="1.6"
      fill="#d4a955"
      transform="rotate(25 50 50)"
    />
    <circle cx="50" cy="50" r="2.4" fill="#d4a955" />
    <path
      d="M 97.04 54.94 L 96.42 59.30 L 95.40 63.59 L 93.98 67.77 L 92.18 71.80 L 90.01 75.65 L 87.49 79.29 L 84.63 82.68 L 81.48 85.79 L 78.04 88.59 L 74.35 91.07 L 70.45 93.20 L 66.36 94.95 L 62.12 96.32 L 57.77 97.30 L 53.35 97.86 L 48.88 98.01 L 44.42 97.74 L 40.00 97.06 L 35.65 95.97 L 31.43 94.48 L 27.35 92.60 L 23.46 90.35 L 19.80 87.74 L 16.39 84.80 L 13.27 81.56 L 10.46 78.03 L 7.98 74.26 L 5.87 70.27 L 4.14 66.09 L 2.80 61.77 L 1.86 57.34 L 1.34 52.83 L 1.24 48.30 L 1.57 43.77 L 2.31 39.28 L 3.47 34.88 L 5.04 30.61 L 7.00 26.49 L 9.33 22.57 L 12.02 18.88 L 15.05 15.45 L 18.38 12.32 L 22.00 9.51 L 25.86 7.04 L 29.94 4.94 L 34.20 3.23 L 38.60 1.92 L 43.12 1.02 L 47.70 0.55 L 52.31 0.50 L 56.90 0.89 L 61.45 1.70 L 65.90 2.93 L 70.23 4.57 L 74.38 6.61 L 78.34 9.02 L 82.05 11.80 L 85.50 14.91 L 88.64 18.34 L 91.45 22.04 L 85.81 25.84 L 83.45 22.59 L 80.79 19.57 L 77.86 16.80 L 74.67 14.32 L 71.27 12.14 L 67.68 10.29 L 63.93 8.77 L 60.05 7.61 L 56.07 6.82 L 52.03 6.40 L 47.97 6.35 L 43.91 6.69 L 39.90 7.40 L 35.97 8.48 L 32.15 9.92 L 28.48 11.71 L 24.99 13.84 L 21.71 16.29 L 18.67 19.03 L 15.89 22.05 L 13.40 25.31 L 11.23 28.80 L 9.38 32.48 L 7.89 36.32 L 6.75 40.28 L 5.99 44.34 L 5.61 48.45 L 5.62 52.59 L 6.00 56.71 L 6.77 60.78 L 7.92 64.76 L 9.43 68.63 L 11.30 72.34 L 13.51 75.87 L 16.04 79.18 L 18.87 82.24 L 21.97 85.03 L 25.32 87.52 L 28.89 89.69 L 32.66 91.52 L 36.58 93.00 L 40.63 94.10 L 44.76 94.83 L 48.95 95.17 L 53.15 95.11 L 57.34 94.67 L 61.47 93.84 L 65.51 92.62 L 69.43 91.04 L 73.18 89.09 L 76.74 86.81 L 80.08 84.20 L 83.16 81.28 L 85.96 78.09 L 88.45 74.65 L 90.62 70.99 L 92.43 67.14 L 93.89 63.14 L 94.96 59.01 L 95.65 54.80 Z"
      fill="#d4a955"
    />
    <polygon points="81.2,27.2 94.4,18.2 96.7,36.0" fill="#d4a955" />
  </>
);

/**
 * `useId` embeds `:` characters, which are fine inside a `url(#...)` fragment
 * but not in a CSS selector; strip them so the id stays safe to query too.
 */
export const useLogoGradientId = () => `logo-face-${useId().replace(/:/g, '')}`;
